import { gql } from '@apollo/client';
import { useMutation } from '@hooks/apollo';

export const REMOVE_ATTACHMENT_MUTATION = gql`
mutation DELETE_ATTACHMENT($input: DeleteAttachmentMutationInput!) {
  deleteAttachment(input: $input) {
     activeRequisition {
      id
      documents {
        id
        status
        documentType
        documentClass
        acceptedMimeTypes
        attachments {
          id
          status
          fileName
          reasonForRejection
        }
      }
    }
  }
}
`;

export const useRemoveAttachmentMutation = (options = {}) => useMutation(
  REMOVE_ATTACHMENT_MUTATION,
  { ...options },
);
